import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { KYMW7006Model } from './kymw7006.model';
import { UpdateFeatureRequestBuyer } from './vo/update-feature-request-buyer.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { VersatileComboBoxComponent } from '../../../commons/kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { GetRequestInfoListService } from './api-services/get-request-info-list.service';
import { GetFeatureCandidateGoodsListService } from './api-services/get-feature-candidate-goods-list.service';
import { UpdateFeatureRequestBuyerService } from './api-services/update-feature-request-buyer.service';
import { GetRequestBuyerService } from './api-services/get-request-buyer.service';
import { GetDelivCatalogIdByOrderCodeService } from './api-services/get-deliv-catalog-id-by-order-code.service';
import { GetOrderCodeByDelivCatalogIdService } from './api-services/get-order-code-by-deliv-catalog-id.service';
import { GetOrderCodeClassListService } from './api-services/get-order-code-class-list.service';
import { GetOrderCodeMediumListService } from './api-services/get-order-code-medium-list.service';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";


/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面を管理するクラス
 *
 * @export KYMW7006Component
 * @class KYMW7006Component
 */
@Component({
  selector: 'app-kymw7006',
  templateUrl: 'kymw7006.component.html',
  styleUrls: ['kymw7006.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW7006Component
  extends PlessViewHelperSub
  implements OnInit {
  public model: KYMW7006Model = new KYMW7006Model();
  private isEditOrderCode = false;
  private isEditCatalogId = false;
  public isFullControl = false;

  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: ElementRef;
  @ViewChild('txti_CatalogId', { static: true }) txti_CatalogId: ElementRef;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VersatileComboBoxComponent;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: VersatileComboBoxComponent;
  @ViewChild('dtg_FeatureRequestList', { static: true }) dtg_FeatureRequestList: FlexGrid;
  @ViewChild('dtg_FeatureCandidateGoodsList', { static: true }) dtg_FeatureCandidateGoodsList: FlexGrid;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;

  /**
   * Creates an instance of KYMW7006Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetRequestInfoListService} getRequestInfoListService
   * @param {GetFeatureCandidateGoodsListService} getFeatureCandidateGoodsListService
   * @param {UpdateFeatureRequestBuyerService} updateFeatureRequestBuyerService
   * @param {GetRequestBuyerService} getRequestBuyerService
   * @param {GetDelivCatalogIdByOrderCodeService} getDelivCatalogIdByOrderCodeService
   * @param {GetOrderCodeByDelivCatalogIdService} getOrderCodeByDelivCatalogIdService
   * @param {GetOrderCodeClassListService} getOrderCodeClassListService
   * @param {GetOrderCodeMediumListService} getOrderCodeMediumListService
   * @param {KYMW00Model} kymw00Model
   * @param {elementRef} ElementRef
   * @memberof KYMW7006Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getRequestInfoListService: GetRequestInfoListService,
    private getFeatureCandidateGoodsListService: GetFeatureCandidateGoodsListService,
    private updateFeatureRequestBuyerService: UpdateFeatureRequestBuyerService,
    private getRequestBuyerService: GetRequestBuyerService,
    private getDelivCatalogIdByOrderCodeService: GetDelivCatalogIdByOrderCodeService,
    private getOrderCodeByDelivCatalogIdService: GetOrderCodeByDelivCatalogIdService,
    private getOrderCodeClassListService: GetOrderCodeClassListService,
    private getOrderCodeMediumListService: GetOrderCodeMediumListService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW7006Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW7006';
    this.model.loginUserId = this.kymw00Model.kymw1001Model.loginUserInfo.UserID;
    this.isFullControl = this.isPermittedFullControl;

    // 依頼先バイヤー取得
    this.getRequestBuyerService.execute(this.model);
  }

  /**
   * 受注コード 変更
   *
   * @memberof KYMW7006Component
   */
  public orderCodeChangedHandler() {
    if (this.isEditCatalogId) {
      return;
    }
    this.isEditOrderCode = true;
    if (this.model.orderCode.length === 7) {
      this.getDelivCatalogIdByOrderCodeService.execute(this.model, () => {
        if (this.model.catalogId !== '') {
          this.cmb_MediumType.disabled = false;
          this.cmb_ClassCode.disabled = false;
          if (this.model.classCodeList.length === 0) {
            this.getOrderCodeClassListService.execute(this.model);
          }
          if (this.model.mediumTypeList.length === 0) {
            this.getOrderCodeMediumListService.execute(this.model);
          }
        }
      });
    } else {
      this.model.catalogId = '';
      this.model.mediumType = '';
      this.model.classCode = '';
      this.model.mediumTypeList = [];
      this.model.classCodeList = [];
      this.cmb_MediumType.disabled = true;
      this.cmb_ClassCode.disabled = true;
      this.clearDisplay();
    }

    this.changeDisplayButtonEnabled();
    setTimeout(() => {
      this.isEditOrderCode = false;
    });
  }

  /**
   * 企画回 変更
   *
   * @memberof KYMW7006Component
   */
  public catalogIdChangedHandler() {
    if (this.isEditOrderCode) {
      return;
    }
    this.isEditCatalogId = true;
    if (this.model.catalogId.length === 8) {
      this.getOrderCodeByDelivCatalogIdService.execute(this.model, () => {
        if (this.model.orderCode !== '') {
          this.cmb_MediumType.disabled = false;
          this.cmb_ClassCode.disabled = false;
          if (this.model.classCodeList.length === 0) {
            this.getOrderCodeClassListService.execute(this.model);
          }
          if (this.model.mediumTypeList.length === 0) {
            this.getOrderCodeMediumListService.execute(this.model);
          }
        }
      });
    } else {
      this.model.orderCode = '';
      this.model.mediumType = '';
      this.model.classCode = '';
      this.model.mediumTypeList = [];
      this.model.classCodeList = [];
      this.cmb_MediumType.disabled = true;
      this.cmb_ClassCode.disabled = true;
      this.clearDisplay();
    }

    this.changeDisplayButtonEnabled();
    setTimeout(() => {
      this.isEditCatalogId = false;
    });
  }

  /**
   * 媒体 変更
   *
   * @memberof KYMW7006Component
   */
  public mediumTypeChangedHandler() {
    this.model.classCode = '';
    this.clearDisplay();
    this.changeDisplayButtonEnabled();
  }

  /**
   * 部門 変更
   *
   * @memberof KYMW7006Component
   */
  public classCodeChangedHandler() {
    this.clearDisplay();
    this.changeDisplayButtonEnabled();
  }

  /**
   * 表示クリア
   *
   * @memberof KYMW7006Component
   */
  private clearDisplay() {
    this.model.featureRequestList = [];
    this.model.featureCandidateGoodsList = [];
  }

  /**
   * 表示ボタン 活性/非活性の制御
   *
   * @memberof KYMW7006Component
   */
  private changeDisplayButtonEnabled() {
    if (this.model.orderCode !== '' && this.model.mediumType !== '' && this.model.classCode !== '') {
      this.btn_Display.nativeElement.disabled = false;
    } else {
      this.btn_Display.nativeElement.disabled = true;
    }
  }

  /**
   * 表示ボタン 押下
   *
   * @memberof KYMW7006Component
   */
  public displayButtonClickHandler() {
    this.getRequestInfoListService.execute(this.model, () => {
      if (this.model.featureRequestList.length === 0) {
        // 検索結果が0件です
        this.dialogService.openAlertGetMessage('W0049');
      } else {
        this.model.displaySucceededOrderCode = this.model.orderCode;
        this.model.displaySucceededMediumType = this.model.mediumType;
      }
      this.featureRequestListSelectionChangedHandler();
    });
  }

  /**
   * 依頼一覧 行選択
   *
   * @memberof KYMW7006Component
   */
  public featureRequestListSelectionChangedHandler() {
    const index = this.dtg_FeatureRequestList.selection.row;
    if (index >= 0) {
      this.model.featureCode = this.dtg_FeatureRequestList.collectionView.items[index].featureCode;
      this.getFeatureCandidateGoodsListService.execute(this.model);
    } else {
      this.model.featureCandidateGoodsList = [];
    }
  }

  /**
   * 商品選定依頼ボタン 押下
   *
   * @memberof KYMW7006Component
   */
  public requestButtonClickHandler() {
    for (const item of this.dtg_FeatureRequestList.collectionView.items) {
      if (item.requestStatus !== '0' || item.requestBuyerUserId === '') {
        // 依頼ステータスが担当未決定ではない もしくは 依頼先バイヤーが設定されていない
        continue;
      }
      this.model.updateFeatureRequestBuyer.push({
        featureCode: item.featureCode,
        featureGoodsRequestId: item.featureGoodsRequestId,
        requestBuyerUserId: item.requestBuyerUserId,
      } as UpdateFeatureRequestBuyer)
    }

    if (this.model.updateFeatureRequestBuyer.length > 0) {
      this.dialogService.openAlertGetMessage(
        'Q0108', ['特集候補商品一覧情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.updateFeatureRequestBuyerService.execute(this.model, () => {
              // 商品選定依頼したら依頼一覧の表示を更新する
              this.getRequestInfoListService.execute(this.model);
            });
          }
        }
      );
    } else {
      // 依頼先バイヤーが設定されていません
      this.dialogService.openAlertGetMessage('W0047');
    }
  }
}
